/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{euclideanHorizontalPlanarArea as e,euclideanPlanarArea as r,createEuclideanPlanarAreaCache as n}from"./euclideanAreaMeasurementUtils.js";import{geodesicArea as t}from"./geodesicAreaMeasurementUtils.js";function o(o,u,i=n()){if("on-the-ground"===u){const r=t(o);return null!=r?r:e(o,i)}return r(o,i)}function u(e,r=n()){return o(e,"on-the-ground",r)}export{u as autoArea2D,o as autoAreaByElevationMode};
